import { AxiosError } from 'axios'
import { useCallback, useMemo } from 'react'
import { useMutation, UseMutationOptions } from 'react-query'
import { OAuthConsentRequest } from '../interfaces/OAuthConsentRequest'
import { OAuthErrorResponse } from '../interfaces/OAuthErrorResponse'
import { useIamManagerOAuth } from '../useIamManagerOAuth'

type Response = { redirect_uri: string }
export type UseOAuthConsentOptions = UseMutationOptions<
  Response,
  AxiosError<OAuthErrorResponse>,
  OAuthConsentRequest
>

export const useOAuthConsent = (options?: UseOAuthConsentOptions) => {
  const { endpoint, consent } = useIamManagerOAuth()
  const mutationKey = useMemo(() => [endpoint, 'consent'], [endpoint])
  const mutationFn = useCallback(
    async (input: OAuthConsentRequest) => (await consent(input)).data,
    [consent]
  )
  return useMutation<Response, AxiosError<OAuthErrorResponse>, OAuthConsentRequest>({
    ...options,
    mutationKey,
    mutationFn,
    retry: false
  })
}
